import { render, staticRenderFns } from "./HeaderCart.vue?vue&type=template&id=4cf0d194&scoped=true&"
import script from "./HeaderCart.vue?vue&type=script&lang=js&"
export * from "./HeaderCart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf0d194",
  null
  
)

export default component.exports